import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import actions from "../redux/actions/customerActions";

function CustomerEditDataPage() {
  const customer = useSelector((store) => store.customer);
  const [customerData, setCustomerData] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    e.preventDefault();
    console.log(data);
    try {
      const response = await axios({
        method: "PUT",
        url: process.env.REACT_APP_API_URL + `/api/customers/${customer.id}`,
        headers: { Authorization: `Bearer ${customer.access_token}` },
        data: data,
      });
      dispatch(actions.updateCustomer(data.firstname));
      navigate(`/customers/${customer.firstname.toLowerCase()}/profile`);
    } catch (err) {
      console.log(err);
    }
  };

  try {
    const getCustomer = async () => {
      const response = await axios({
        method: "GET",
        url: process.env.REACT_APP_API_URL + `/api/customers/${customer.id}`,
        headers: { Authorization: `Bearer ${customer.access_token}` },
      });
      response && setCustomerData(response.data);
      console.log(response.data);
    };

    useEffect(() => {
      getCustomer();
    }, []);
  } catch (error) {
    console.log("Error: ", error);
  }

  return (
    customerData && (
      <div className="animate__animated animate__fadeIn h-100 d-flex justify-content-center align-items-center">
        <div className="container my-0 px-4 px-lg-5 pt-5 mt-5">
          <div className="row gx-4 gx-lg-5 justify-content-center align-items-center mb-5 h-100">
            <div className="col-md-10 col-lg-8 col-xl-7 shadow-sm border">
              <div className="contenido-card d-flex flex-column align-items-center">
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  id="contactForm"
                  className="mb-3"
                >
                  <div className="w-100">
                    <h1 className="h2 text-start">Edit profile</h1>
                  </div>
                  <div className="row gx-3">
                    <div className="col-md-6 col-sm-12">
                      <label className="pt-4" htmlFor="firstname">
                        Name
                      </label>
                      <input
                        autoComplete="off"
                        className="form-control bg-light"
                        type="text"
                        placeholder="Write yor firstname..."
                        defaultValue={customerData.firstname}
                        {...register("firstname", { required: true })}
                      />
                      {errors.firstname && (
                        <span className="f-roboto fs-7 text-danger">
                          This field is required
                        </span>
                      )}
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <label className="pt-4" htmlFor="lastname">
                        Lastname
                      </label>
                      <input
                        autoComplete="off"
                        className="form-control bg-light"
                        id="lastname"
                        type="text"
                        placeholder="Write you lastname..."
                        defaultValue={customerData.lastname}
                        {...register("lastname", { required: true })}
                      />
                      {errors.lastname && (
                        <span className="f-roboto fs-7 text-danger">
                          This field is required
                        </span>
                      )}
                    </div>
                  </div>

                  <label htmlFor="email" className="mt-3">
                    E-mail
                  </label>
                  <input
                    autoComplete="off"
                    className="form-control bg-light"
                    id="email"
                    type="email"
                    placeholder="Write your email address..."
                    defaultValue={customerData.email}
                    {...register("email", { required: true })}
                  />
                  {errors.email && (
                    <span className="f-roboto fs-7 text-danger">
                      This field is required
                    </span>
                  )}

                  <label htmlFor="password" className="mt-3">
                    Password
                  </label>
                  <input
                    autoComplete="off"
                    className="form-control bg-light"
                    id="password"
                    type="password"
                    placeholder="Place your current or a new password..."
                    defaultValue={"****"}
                    {...register("password")}
                  />

                  <label htmlFor="phoneNumber" className="mt-3">
                    Phone Number
                  </label>
                  <input
                    autoComplete="off"
                    className="form-control bg-light"
                    id="phoneNumber"
                    type="text"
                    placeholder="Write your phone number..."
                    defaultValue={customerData.phoneNumber}
                    {...register("phoneNumber", { required: true })}
                  />
                  {errors.phoneNumber && (
                    <span className="f-roboto fs-7 text-danger">
                      This field is required
                    </span>
                  )}

                  <label htmlFor="address" className="mt-3">
                    Address
                  </label>
                  <input
                    autoComplete="off"
                    className="form-control bg-light"
                    id="address"
                    type="text"
                    placeholder="Write your address..."
                    defaultValue={customerData.address}
                    {...register("address", { required: true })}
                  />
                  {errors.address && (
                    <span className="f-roboto fs-7 text-danger">
                      This field is required
                    </span>
                  )}

                  <br />

                  <div className="w-100 d-flex justify-content-end">
                    <button
                      className="btn btn-submit btn-yellow px-3 text-uppercase w-100 rounded my-3"
                      type="submit"
                    >
                      Update
                    </button>
                  </div>
                </form>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default CustomerEditDataPage;
